import React from 'react';

import { Route, Routes } from 'react-router-dom';

import TemplateList from './list';

function Templates() {
  return (
    <Routes>
      <Route element={<TemplateList />} path='/*' />
    </Routes>
  );
}

export default Templates;
